// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9caa90c6","703":"45cabb85"}[chunkId] + ".chunk.js";
};